import React from 'react'
import className from 'classnames/bind'
import { useHistory } from 'react-router'
import { useSelector } from 'react-redux'

import style from './MyhouseReviewItem.module.scss'

import IconNew from '@Ui/images/myhouse/IconNew.svg'
import useBoard from '@Hooks/myhouse/board/useBoard'
import { RootState } from '@Root/slices'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import { THUMBNAIL } from '@Root/contants'
import { handleNclickMix } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const cx = className.bind(style)

type Props = {
  sequence?: any
  title?: any
  readCount?: any
  modifiedDate?: any
  userNickName?: any
  userIdNo?: any
  content?: any
  imageUrl?: any
  onClick?: any
}

const MyhouseResidentItem: React.FC<Props> = ({ sequence, content, readCount, modifiedDate, userNickName, imageUrl }: Props) => {
  const myhouse = useSelector((state: RootState) => state.myhouse)
  const { complexNo } = myhouse
  const { isRecent, isVisited, getSimplifiedDate } = useBoard()
  const history = useHistory()
  return (
    // 방문한 리뷰일 시 is_visited 클래스 추가

    <a
      href={`${LAND_SERVICE_PREFIX_URL.MYHOUSE_COMPLEXES}/${complexNo}/reviews/${sequence}`}
      className={cx('link', isVisited(sequence) && 'is_visited')}
      onClick={handleNclickMix(NCLICK.MY_HOUSE.REVIEW_LIST.DETAIL)}
    >
      <div className={cx('info')}>
        <strong className={cx('title')}>
          {isRecent(modifiedDate) && (
            <>
              <IconNew />
              <span className="blind">new</span>
            </>
          )}
          {content}
        </strong>
        <span className={cx('date')}>{getSimplifiedDate(modifiedDate)}</span>
        <span className={cx('view')}>조회 {readCount}</span>
        <em className={cx('writer')}>{userNickName}</em>
      </div>
      {!!imageUrl && (
        <div className={cx('wrap_image')}>
          <img src={`${imageUrl}?${THUMBNAIL.F176_176}`} alt="" className={cx('image')} />
        </div>
      )}
    </a>
  )
}

export default MyhouseResidentItem
